
var HierarchyView = (function () {
  var COPYRIGHT = "(c) Copyright The Australian e-Health Research Centre, CSIRO, 2014",
      request_id = 0,
      limit,
      width, height,
      scale = 1.0,
      wrap,
      outer,
      vis,
      banner,
      zoom,
      nodes = [], visibleNodes = [],
      links = [], visibleLinks = [],
      roots = [],
      lineFunction,
      listeners = [],
      bundleListeners = [];

  // We allow a blank system and version in the coding (concepts), and a blank version in the data (d)
  function matchesConcept(concepts, d) {
    return concepts.filter(function (c) {
      return c.c === d.code && (!c.s || c.s === d.system) && (!c.v || !d.version || c.v === d.version);
    }).length > 0;
  }

  return {
    settings: {
      containerId: "#hierarchyView",        // "#chart"
      width: 900,
      height: 500,
      wrap: 20,
      bundleSize: 30,
      help: null,
    },

    recenter: function () { update(); },

    init: function () {
      var s = this.settings,
          watermarks,
          help;

      wrap = s.wrap;
      limit = s.bundleSize;

      zoom = d3.behavior.zoom().scaleExtent([0.5,4]).on("zoom", redraw);
      outer = createSVG(s.containerId, s.width, s.height);

      banner = createBanner(outer, 30, 60);

      watermarks = createWatermarks(outer);
      if (s.help) {
        help = createHelp(watermarks, s.help);
      }
      vis = createView(outer);

      lineFunction = function (arg, ctx) {
        ctx = ctx || {};
        if ((ctx.source && !ctx.source.visible) || (ctx.target && !ctx.target.visible)) return;
        var s = d3.svg.line()
          .x(function(d) { return d.x; })
          .y(function(d) { return d.y; })
          .interpolate("basis")(arg);
if (s.indexOf("NaN") >= 0) {
  console.error("NaN in path", arg, ctx);
}
       return s };
    },

    setBanner: function (bannerText) {
      banner.text(bannerText);
    },

    showConcepts: function (rows, cb, foci) {
      request_id++;

      const uu = {};
      (rows||[]).forEach(r => {uu[r.system+'|'+r.version+'|'+r.code] = {c:r.code, s:r.system, v:r.version, display:r.display, x:r.extension};})
      var initRows = [];
      var codings = Object.values(uu);

      function getProperties(c) {
        var exts = (c.x || []).filter(x => 'http://hl7.org/fhir/5.0/StructureDefinition/extension-ValueSet.expansion.contains.property' === x.url);
        if (0 === exts.length) {return;}
        var properties = {
          inactive: false,
          primitive: false,
          directParents: [],
        };
        exts.forEach(x => {
          var prop, value;
          x.extension.forEach(xx => {
            if ('code' === xx.url) {
              prop = xx.valueCode;
            } else if ('value' === xx.url) {
              value = xx.valueCode || xx.valueBoolean;
            }
          });
          if ('inactive' === prop) {
            properties.inactive = value;
          } else if ('sufficientlyDefined' === prop) {
            properties.primitive = !value;
          } else if ('parent' == prop) {
            properties.directParents.unshift(value);
          }
        });
        return properties;
      }

      codings = codings.filter(c => {
        var properties = getProperties(c);
        if (!properties) {
          return true;
        }
        var row = {
          id: c.c, code: c.c, system: c.s, version: (c.v || version), display: c.display,
          directParents: properties.directParents, inactive: properties.inactive, primitive: properties.primitive,
        };
        initRows.push(row);
        return false;
      });

      // banner.attr("visibility", codings.length > 0 ? "hidden" : "visible");

      function resultToRows(offset, result) {
        var rows = (result||[]).map(function (l, i) {
          var params = (l.resource.parameter || []),
              name,
              version,
              primitive = true,	// default to true
              inactive = false,
              directParents = [];

          params.forEach(function (p) {
            if ('display' === p.name) name = p.valueString;
            if ('version' === p.name) version = p.valueString;
            if ('inactive' === p.name) inactive = p.valueBoolean;
            if ('property' === p.name) {
              if (p.part.find(function (pp) { return 'code' === pp.name && 'parent' === pp.valueCode; })) {
                p.part.forEach(function (pp) { if ('value' === pp.name) directParents.unshift(pp.valueCode || pp.valueString); });
              }
              if (p.part.find(function (pp) { return 'code' === pp.name && 'inactive' === pp.valueCode; })) {
                p.part.forEach(function (pp) { if ('valueBoolean' === pp.name) inactive = pp.valueBoolean; });
              }
              if (p.part.find(function (pp) { return 'code' === pp.name && 'sufficientlyDefined' === pp.valueCode; })) {
                p.part.forEach(function (pp) { if ('valueBoolean' === pp.name) primitive = !pp.valueBoolean; });
              }
            }
          });

          return {id: codings[offset+i].c, code: codings[offset+i].c, system: codings[offset+i].s, version: (codings[offset+i].v || version), display: name, directParents: directParents, inactive: inactive, primitive: primitive, };
        });

        return rows;
      }

      function processRows(rows) {
// console.log('rows', codes.length, Date.now()-start, (Date.now()-start)/codes.length);
        // clear out old state
        nodes.length = 0;
        links.length = 0;
        roots.length = 0;

        // map from node id to index in nodes array
        var nodeIndex = {};

        rows.forEach(function (d) {
          d.id = d.id || (d.system + '/' + d.code);
          d.display = d.display || d.code;
          nodeIndex[d.code] = nodes.push(d) - 1;
          // if (!d.directParents) { roots.push(d); }
        });

        rows.forEach(function (d) {
          var p = d.directParents ? d.directParents : [],
              dpExists = false;

          p.forEach(function (dd) {
            var source = nodes[nodeIndex[dd]],
                target = nodes[nodeIndex[d.code]];

            // ignore parents of leaf children
            if (typeof source === "undefined") {
              return;
            } else {
              dpExists = true;

              if (! source.children ) { source.children = []; }
              source.children.push(target);
            }
          });

          if (!dpExists) {
// console.log(roots.length + "\t"+d.display + "\t" + roots.reduce(function(b,r) {console.log(r.id == d.id); return b || r.id === d.id;}, false));
            d.directParents = null;
            roots.push(d);
          }

        });

        bundle(foci || []);

        // build links array from node.children data
        nodes.forEach(function (n) {
          if (n.children) {
            n.children.forEach(function (c) {
              links.push({"source": n, "target": c, value: 1, visible: c.visible});
            });
          }
        });

        // update visiblity status
        updateVisibility([]);

        update();
      }

// var start = Date.now();

      function getChunks(req, allRows, start, n, cb) {
//console.log('process chunk ' + start +' '+ allRows.length +' '+ n);
        var end = start + n,
            chunk = codings.slice(start, end).filter(c => !c.directParents);

        Endpoint.lookupConcepts({
          codings: chunk,
          fields: ['parent', 'display', 'inactive', 'sufficientlyDefined', 'version'],
        }, function (error, result) {
          if (req != request_id) {
            return;
          }

          if (error) {
            console.log('can not show hierarchy');
            if (cb) cb(error);
          } else {
            var rows = resultToRows(start, result);
            allRows = allRows.concat(rows);

            processRows(allRows.slice());
          }

          if (req != request_id) {
            return;
          }

          if (end < codings.length) {
            getChunks(req, allRows, end, n*2, cb);
          } else if (!error) {
            if (cb) cb();
          }
        });
      }

      getChunks(request_id, initRows, 0, 1000, cb);

    },

    setFocus: function (concepts) {
      vis.selectAll(".label rect")
          .transition().duration(200)
          .attr("stroke", function (d) { return matchesConcept(concepts, d) ? "darkred" : "dimgray"; })
          .attr("stroke-width", function (d) { return matchesConcept(concepts, d) ? 1.5 : 1; });
    },

    highlight: function (concepts) {
      vis.selectAll(".label text")
          .classed("highlight", function (d) { return matchesConcept(concepts, d); });
    },

    resize: function (w, h) {
      // update width and height
      width = w;
      height = h;

      outer.attr("width", width)
           .attr("height", height);
      outer.select(".watermark")
           .attr("transform", "translate(0," + (height - 100) + ")");
      outer.select(".watermark text")
           .attr("x", function (d) { var b = this.getBBox(); return width - b.width - 5 });
      outer.select("#help")
           .attr("transform", "translate("+ (width-14) +"," + (114-height) + ")");
    },

    addListener: function (listener) { listeners.push(listener); },
    addBundleListener: function (listener) { bundleListeners.push(listener); },
  };

  function createSVG(selector, width, height) {
    var outer =
      d3.select(selector).append("svg")
        .attr("class", "hierarchy")
        .attr("width", width)
        .attr("height", height)
        .attr("overflow", "hidden")        // for IE10
        .style("border", "solid 1px gray")
        .call(zoom);

    outer
        .append("defs")
          .append("marker")
          .attr("id", "markerArrow")
          .attr("viewBox", "0 -5 12 10")
          .attr("refX", "11")
          .attr("markerWidth", "10")
          .attr("markerHeight", "10")
          .attr("orient", "auto")
          .append("path")
            .attr("d", "M1,-4 L11,0 L1,4 L1,-4")
            .style({fill: "white", "stroke": "black", "stroke-width": 1});

    return outer;
  }

  function createView(container) {
    var vis = container.append("g");

    vis.attr("transform", "translate(0,0) scale(1)");
    // create "layers" for our display elements so that they are drawn in the right
    // order - effectively simulates z-order (SVG doesn't know about z-order)
    vis.append("g").attr("id", "links")
    vis.append("g").attr("id", "nodes")
    vis.append("g").attr("id", "labels")

    return vis;
  }

  function createBanner(container, x, y) {
    var banner =
            container.append("g").attr("class", "banner");

    return banner
             .append("text")
             //.attr("visibility", "hidden")
             .attr("x", x)
             .attr("y", y)
             .style({"fill": "gray", "font-family": "Tahoma, Verdana, Segoe, sans-serif", "font-size": "32pt"})
             .text("initialising...");
  }

  function createWatermarks(container) {
    var watermarks =
            container.append("g").attr("class", "watermark");

/*
    watermarks
        .append("svg:image")
        .attr("x", 5)
        .attr("y", 5)
        .attr("width", 100)
        .attr("height", 100)
        .attr("xlink:href", "CSIRO_Grad_RGB_lr.jpg");
*/
    watermarks
        .append("text")
        .attr("y", 90)
        .style({fill: "gray", "font-family": "Tahoma, Verdana, Segoe, sans-serif", "font-size": "8pt"})
        .text("\u00A9 Australian e-Health Research Centre");

    return watermarks;
  }

  function createHelp(container, callback) {
    var help = container.append("g");

    help.attr("id", "help")
        .style("cursor", "pointer")
        .on("click", callback);
    help.append("circle")
        .attr("cx", 0).attr("cy", 0)
        .attr("r", 10)
        .style({fill: "#00A9CE", stroke: "#00A9CE"});
    help.append("text")
        .attr("x", -3.5).attr("y", 6)
        .style("fill", "white")
        .text("?");

    return help;
  }

  function redraw() {
//if (d3.event.sourceEvent) {
//  console.log(d3.event.sourceEvent.srcElement);
//}
    scale = d3.event.scale;
    vis.attr("transform", "translate(" + d3.event.translate + ")" +
                          " scale(" + (scale) + ")");
  }

  function getPath(d) {
    var sx = d.source.x+(d.source.width),
        tx = d.target.x,
        sy = d.source.y,
        ty = d.target.y;

    return [
      {x:sx, y:sy},
      // {x:sx+10, y:sy},
      {x:sx+(tx-sx)/1.5, y:sy+(ty-sy)/10},
      // {x:tx-10, y:ty},
      {x:tx, y:ty}
    ];
  }

  function computeSize(d) {
     var margin = 3,
         pad = 1,
         b = this.getBBox(),
         extra = 2 * margin + 2 * pad;

     d.width = b.width + extra;
     d.height = b.height + 0*extra;
  };

  function update() {
    var max_depth = computeDepths(roots),
        makeLabel, makeSpans,
        label, link;

    // Update the links
    link = vis.select("#links").selectAll(".link")
             .data(visibleLinks, function(d) { return d.source.id + " : " + d.target.id; });

    // Enter any new links.
    link.enter()
        .insert("path")
        .attr("class", "link")
        .attr("d", function (d) {
          var px = 0, py = 20 + height/2,
              kx = Math.max(110, (width - 40) / (max_depth+1));
          (d.source.parents || []).slice(0,1).forEach(function (p) {px = nodeDepth(p)*kx;});
          return px ? lineFunction([{x:px, y:py},{x:px, y:py},{x:px, y:py}]) : null;
        })
        .style({opacity: 0})        // , "marker-mid": "url(#markerArrow)")
        .attr("fill", "none")
        .attr("stroke", "gray"); //"#9ecae1");

    // Exit any old links.
    link.exit().transition().style({opacity: 0}).remove();

    // append rect first so that the rectangle renders underneath the actual text
    makeLabel = function(d) {
      var el = d3.select(this), r1, r2;

      el.append("title").text(d.code+(d.fullySpecifiedName?"\n"+d.fullySpecifiedName:""));

      r1 = el.append("rect")
        .attr("id", function (d) { return "rect-"+d.code; })
        .attr("rx", 6).attr("ry", 6)        // rounded corners
        .attr("x", 0).attr("y", 0)
        .attr("stroke", "dimgray");

      if (false === d.primitive) {
        r2 = el.append("rect")
          .attr("id", function (d) { return "drect-"+d.code; })
          .attr("rx", 6).attr("ry", 6)        // rounded corners
          .attr("x", 1).attr("y", 1)
          .attr("stroke", "dimgray")
          .style({fill: color, "fill-opacity": 1});
      }

      el.append("text")
        .attr("class", "tlabel")
        .each(makeSpans)
        .each(computeSize);

      // can't position rectangle until text has been added and size computed
      if (false === d.primitive) {
        r1
          .attr("rx", 8).attr("ry", 8)        // rounded corners
          .attr("x", -1).attr("y", -1)
          .attr("width", function (d) {return d.width + 2;})
          .attr("height", function (d) {return d.height + 2;})
          .style({fill: "white", "fill-opacity": 1});
        r2
          .attr("width", function (d) {return d.width - 2;})
          .attr("height", function (d) {return d.height - 2;});
      } else {
        r1
          .attr("x", 0).attr("y", 0)
          .attr("width", function (d) {return d.width;})
          .attr("height", function (d) {return d.height;})
          .style({fill: color, "fill-opacity": 1});
      }
    }

    // wraps the label and creates the required tspans
    makeSpans = function (d) {
       var thisText = this,
           el = d3.select(this),
           lbl = Endpoint.trimLabel(d.display),
           lines = lbl.match(new RegExp("(.{1,"+wrap+"}[\\S]*)[\\s]*", "g")),
           h = 0;
       (lines || [lbl]).forEach(function(l,i) {
         var tspan = el.append("tspan")
             .text(l.replace(/\s*$/, ""))
             .attr("x", 4);
         if (i == 0) { h = thisText.getBBox().height-4; }
         tspan.attr("dy", h);
       });
    };

    const lang = Endpoint.getLanguage()+'_';
    visibleNodes.forEach(function(d) {
      d.id = lang+d.id+d.version;
    });

    label = vis.select("#labels").selectAll(".label")
         .data(visibleNodes, function(d) { return d.id; });
    label.enter().append("g")
         .attr("class", "label")
         .attr("id", function (d) { return "label-" + d.code; })
         .style({opacity: 0})
         .attr("transform", function (d) {
           var kx = Math.max(110, (width - 40) / (max_depth+1)),
               px = 0, py = 20 + height/2;
           (d.parents || []).slice(0,1).forEach(function (p) {px = nodeDepth(p)*kx;});
           return px ? "translate("+px+", "+py+")" : "";
         })
         .each(makeLabel)
         .each(function (d) {
           var g = d3.select(this);
           if (d.noclick) {
             g.style("cursor", "default");
           } else {
             g.on("click", HistoryManager.userAction(click));
           }
         });

    // Exit any old labels.
    label.exit().transition().style({opacity: 0}).remove();

    layout(label, link);
  }

  function click (d) {
    if (d.bundle) {
      // update visiblity status
      updateVisibility([d]);
      // re-display
      update();

      bundleListeners.forEach(function (callback) {
        try {
          callback(d);
        } catch (err) {
          console.log(err);
        }
      });
    } else {
      updateVisibility([]);
      update();

      listeners.forEach(function (callback) {
        try {
          callback([{c: d.code, s: d.system, v: d.version}]);
        } catch (err) {
          console.log(err);
        }
      });
    }

  }

  function ch(d) {
    var theChildren = [];
    visibleLinks.forEach(function(l,i) {
      if (d === l.source && l.target.visible) {
        theChildren.push(l.target);
      }
    });
    return theChildren;
  }

  function layout(label, link) {
    var max_width = [], heights = [], max_heights = [],
        linex = 60,
        xpos = 0,
        kx, ky,
        hoffset, oy;

    label.select(".tlabel")
        .each(computeSize)
        .each(function (d) {
          var nd = nodeDepth(d);
          max_width[nd] = Math.max(d.width, (max_width[nd] || 0));
          if (!heights[nd]) { heights[nd] = {}; }
          // heights[nd].push(d.height);
          heights[nd][d.id] = d.height;
        });

    kx = max_width.map(function (w) { xpos += linex+w; return xpos-w; });

    // in case width is greater than view width, ensure deepest nodes are visible
    hoffset = Math.min(0, (width/scale) - xpos - 10);

    ky = heights.map(function (hs,i) {
      var ypos = 0, ks = {};
      // iterate over node list so sort-order is preserved
      visibleNodes
        .filter(function (d) { return i === nodeDepth(d); })
        .forEach(function (d) {
          var k = d.id;
          var h = hs[k];
          ypos += 6+h; 
          max_heights[i] = ypos-6;
          ks[k] = ypos-h;
        });
      return ks;
    });

    visibleNodes.forEach(function(d) {
      if (!d.fixed) {
        var nd = nodeDepth(d);

        if (true || !(typeof nd === "undefined")) {
          d.x = hoffset + kx[nd];
          d.y = (height - max_heights[nd])/2 + ky[nd][d.id] + d.height/2;

          if (isNaN(d.y)) {
            console.log("Internal error, NaN detected for: " + d.display);
            d.y = 0;
          }
        }
      }
    });

    // re-centre, adjusting for any scaling that might have happened
    oy = height - (scale * height);
    vis.transition(500)
      .call(zoom.translate([0,oy/2]).event);

    link
        .transition().duration(500)
        .attr("d", function(d) { return lineFunction(getPath(d), d); })
        .style({opacity: 1})
        ;

    label
        .transition().duration(500)
        .attr("transform", function (d) { return "translate(" + (d.x) + ", " + (d.y - d.height/2) + ")"; })
        .style({opacity: 1})
        ;
  }

  // Color primitive concepts blue, fully-defined concepts purple
  function color(d) {
    if (d.bundle) return "white";
    return d.inactive ? "yellow" : (undefined === d.primitive ? "#C7F2F3" : (true === d.primitive ? "#9cf" : "#ccf"));
  }

  // Compute (maximal) depth of each node and position within each level
  //
  // var nodeDepth = function (n) { return n.depth; };
  function nodeDepth (n) { return n.md; }

  function computeDepths(roots) {
    var max_depth = 1;

    function maxDepth(node, dd) {
      if (node.md < 0) {
        node.md = Math.max(node.depth||dd, (visible(node.children) || []).reduce(function (b, c) { return Math.min(b, maxDepth(c, dd+1)); }, max_depth + 1) - 1);
      }
      return node.md;
    }

    function computeDepthsP(node, parent, dd) {
      if (!node.parents) {
        node.parents = [];
      }
      // update this node's parent list
      if (parent && parent.visible && node.parents.indexOf(parent) < 0) node.parents.push(parent);

      // set node.depth as 1 more than max depth of (currently known) parents
      node.depth = node.parents.reduce(function(b, p) {return Math.max(p.depth||dd, b);}, -1) + 1;

      ch(node).forEach(function (child) {
        computeDepthsP(child, node, dd+1);
      });

      max_depth = Math.max(node.depth, max_depth);
    }

    nodes.forEach(function (n) { n.md = -1; });

    // traverse DAG from root and compute maximal depth
    roots.forEach(function (r) {computeDepthsP(r, null, 0);});
    roots.forEach(function (r) {maxDepth(r, 0);});

    // Sort nodes based on depth, and then alphabetically for a common depth
    // TODO - adjust sort based on common parents
    (visibleNodes || []).sort(function (a, b) {
      var cmp = nodeDepth(a) - nodeDepth(b);
      return 0 == cmp ? a.display.replace(/^\d+\| /, '').localeCompare(b.display.replace(/^\d+\| /, '')) : cmp;
    });

    return max_depth;
  }

  // -----
  // functions to bundle up nodes into groups

  function visible(items) {
    return (items || []).filter(function (i) { return i.visible; });
  }

  function bundle(foci) {
    nodes.forEach(function (n) {
      if (n.children) {
        n.children.sort(function (a, b) {
            return a.display.localeCompare(b.display);
          });

          n.children.forEach(c => {
          foci.forEach(f => {
            if (c.code === f.c && c.system === f.s && c.version === f.v) {
              c.visible = true;
            }
          })
        });

        var padding = Math.floor(Math.log10(n.children.length));

        while (n.children.length > limit) {
          const len = n.children.length;
          var k = Math.ceil(n.children.length/limit);
          split(n, n.children, k, Math.ceil(n.children.length/k), padding);
          if (len === n.children.length) {
            console.error('Internal Error: split did not reduce size');
            break;
          }
        }
      }
    });
  }

  function getLabel(n, first) {
    return n.bundle ? (first ? getLabel(n.children[0], first) : getLabel(n.children[n.children.length-1], first)) : n.display;
  }

  function pad(num, len) {
    var a = Math.floor(Math.log10(num || 1));
    return Array(len-a+1).join("0") + num;
  }

  function split(n, children, k, limit, padding) {
    const newChildren = children.filter(c => c.visible && !c.bundle);

    var bundle,
        count = 0,
        total = children.length - newChildren.length;

    children.forEach(function (c, i) {
      if (!c.visible || c.bundle) {
        if (!count) {
          var m = Math.min(total, i + limit) - 1,
            relativeId = "_" + i + "," + m,
            from = i + 1,
            to = m + 1;

          if (c.bundle) {
            from = c.from;
            to = children[m].to;
          }

          bundle = {
            id: n.id + relativeId,
            code: n.code + relativeId,
            display: pad(from, padding) + "| " + getLabel(c) + "\n...\n" + pad(to, padding) + "| " + getLabel(children[m]),
            primitive: undefined,
            children: [],
            directParents: n.code,
            bundle: true,
            visible: true,
            from: from,
            to: to,
          };
          nodes.push(bundle);
          newChildren.push(bundle);
        }
        bundle.children.push(c);
        count++;
        if (count >= limit) {
          count = 0;
        }
      }
    });

    n.children = newChildren;
    return n.children;
  }

  function updateVisibility(bundles) {
    // root nodes are always visible
    nodes.forEach(function (c) {
       c.visible = roots.indexOf(c) >= 0;
    });

    bundles.forEach(function (b) {
      bundleAncestors(bundles, b);
    });

    // link visibilty depends on source node
    links.forEach(function (l) {
      l.visible = !l.source.bundle || (bundles.indexOf(l.source) >= 0 || bundles.indexOf(l.target) >= 0);
      if (l.visible) {
        l.target.visible = true;
      }
    });

    visibleLinks = visible(links);
    visibleNodes = visible(nodes);
  }

  function bundleAncestors(bundles, b) {
    b.parents.forEach(function (p) {
      if (p.bundle) {
        bundles.push(p);
        bundleAncestors(bundles, p);
      }
    });
  }

}());
